module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.siteSelect) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "Site Required",
      "description": "Please select a site to successfully save this provider.",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('select-site', {
    attrs: {
      "no-form": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.site_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "site_id", $$v)
      },
      expression: "form.site_id"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.localNew && this.form.active && this.form.active.length > 0) ? _c('el-row', [_c('h4', [_vm._v("Active Customers")]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), (_vm.isTowerCo()) ? _c('th', [_vm._v("Cust. Status")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Provider")]), _vm._v(" "), _c('th', [_vm._v("Prov. Status")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), (_vm.canAccess('finance')) ? _c('th', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Entrance Fee")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance')) ? _c('th', {
    staticClass: "hidden-md-and-down",
    attrs: {
      "align": "right"
    }
  }, [_vm._v("ROW Fee")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v("Serivce Starts")]), _vm._v(" "), (_vm.canAccess('finance')) ? _c('th', [_vm._v("Expiry")]) : _vm._e()])]), _vm._v(" "), _c('tfoot'), _vm._v(" "), _c('tbody', _vm._l((_vm.form.active), function(bh, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.isTowerCo()) ? _c('td', [_vm._v(_vm._s(bh.status))]) : _vm._e(), _vm._v(" "), (_vm.isTowerCo()) ? _c('td', [_vm._v(_vm._s(bh.organisation.name))]) : _c('td', [_c('b', [_vm._v(_vm._s(_vm.form.active.length))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.providerShortName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.backhaulType))]), _vm._v(" "), (_vm.canAccess('finance')) ? _c('td', {
      staticClass: "hidden-md-and-down"
    }, [_vm._v(_vm._s(_vm.formatNumber(bh.depositFee)))]) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance')) ? _c('td', {
      staticClass: "hidden-md-and-down"
    }, [_vm._v(_vm._s(_vm.formatNumber(bh.rightOfWayCharges)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "hidden-md-and-down"
    }, [_vm._v(_vm._s(_vm.formatDate(bh.startService)))]), _vm._v(" "), (_vm.canAccess('finance')) ? _c('td', [_vm._v(_vm._s(_vm.formatDate(bh.expiry)))]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.isManager('project|maintenance|finance|admin')) ? _c('edit-pane', {
    ref: "bh",
    attrs: {
      "title": "Backhaul Provider",
      "editable": _vm.canAccess('project|finance|admin|management') && _vm.isTowerCo(),
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }, [_c('div', {
    staticClass: "padded"
  }, [_c('el-form', {
    attrs: {
      "label-position": this.isDesktop || this.isTablet ? 'top' : 'left',
      "label-width": "134px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('select-backhaul-status', {
    attrs: {
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    on: {
      "change": _vm.resetDates
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), (_vm.localNew) ? _c('el-col', {
    staticClass: "bg-primary-lighten-1",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Serivce Start",
      "placeholder": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.startService),
      callback: function($$v) {
        _vm.$set(_vm.form, "startService", $$v)
      },
      expression: "form.startService"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.status === 'Terminated') ? _c('el-col', {
    staticClass: "bg-danger-lighten-2",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Terminated",
      "placeholder": "Terminated",
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    model: {
      value: (_vm.form.terminateService),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminateService", $$v)
      },
      expression: "form.terminateService"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [(!_vm.providerId) ? _c('select-backhaul-provider', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.provider_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "provider_id", $$v)
      },
      expression: "form.provider_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('select-backhaul-type', {
    attrs: {
      "label": "Backhaul Type",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.backhaulType),
      callback: function($$v) {
        _vm.$set(_vm.form, "backhaulType", $$v)
      },
      expression: "form.backhaulType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": _vm.mq.sm,
      "md": _vm.mq.md,
      "lg": _vm.mq.lg
    }
  }, [_c('text-input', {
    attrs: {
      "label": "LRD Provider",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.lrdProvider),
      callback: function($$v) {
        _vm.$set(_vm.form, "lrdProvider", $$v)
      },
      expression: "form.lrdProvider"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8
    }
  }, [_c('switch-input', {
    attrs: {
      "label": (_vm.form.providerShortName ? _vm.form.providerShortName : 'Provider') + ' Exclusive',
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    model: {
      value: (_vm.form.exclusive),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusive", $$v)
      },
      expression: "form.exclusive"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Entrance",
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    model: {
      value: (_vm.form.deposit),
      callback: function($$v) {
        _vm.$set(_vm.form, "deposit", $$v)
      },
      expression: "form.deposit"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Right of Way",
      "disabled": _vm.disabled && _vm.isTowerCo()
    },
    model: {
      value: (_vm.form.rightOfWay),
      callback: function($$v) {
        _vm.$set(_vm.form, "rightOfWay", $$v)
      },
      expression: "form.rightOfWay"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.section),
      callback: function($$v) {
        _vm.section = $$v
      },
      expression: "section"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Contract")])]), _vm._v(" "), (_vm.form.started) ? _c('span', [_vm._v(": "), _c('b', [_vm._v(_vm._s(this.formatNumber(_vm.form.tenor, 0)))]), _vm._v(" yr. from "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.started)))]), _vm._v(" to "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.expiry)))])]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    staticClass: "padded",
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 9
    }
  }, [_c('text-input', {
    attrs: {
      "placeholder": "Contract No",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.contractNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "contractNo", $$v)
      },
      expression: "form.contractNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('date-input', {
    attrs: {
      "placeholder": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.started),
      callback: function($$v) {
        _vm.$set(_vm.form, "started", $$v)
      },
      expression: "form.started"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 20,
      "md": 9,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "placeholder": "Tenor"
    }
  }, [_c('el-slider', {
    attrs: {
      "min": 1,
      "max": 24,
      "step": 1,
      "show-stops": "",
      "show-input": !_vm.localNew,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.tenor),
      callback: function($$v) {
        _vm.tenor = $$v
      },
      expression: "tenor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('el-form-item', [_c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.form.expiry)))]), _vm._v(" (" + _vm._s(_vm.formatDate(_vm.form.expiry)) + ")\n                ")])], 1)], 1)], 2), _vm._v(" "), (_vm.form.exclusive && _vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Exclusivity")])]), _vm._v(" "), (_vm.form.exclusiveExpiry) ? _c('span', [_vm._v(": expires on "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.exclusiveExpiry)))])]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    staticClass: "padded",
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Fee",
      "placeholder": "Fee",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveFee", $$v)
      },
      expression: "form.exclusiveFee"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Expiry",
      "placeholder": "Expiry",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveExpiry),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveExpiry", $$v)
      },
      expression: "form.exclusiveExpiry"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('select-frequency', {
    attrs: {
      "label": "Frequency",
      "placeholder": "Frequency",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveFrequency),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveFrequency", $$v)
      },
      expression: "form.exclusiveFrequency"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.form.deposit && _vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Deposit / Entrance")])]), _vm._v(" "), (_vm.form.depositPaid) ? _c('span', [_vm._v(": paid on "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.depositPaid)))])]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    staticClass: "padded",
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Entrance Fee",
      "placeholder": "Fee",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.depositFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "depositFee", $$v)
      },
      expression: "form.depositFee"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Date Paid",
      "placeholder": "Date Paid",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.depositPaid),
      callback: function($$v) {
        _vm.$set(_vm.form, "depositPaid", $$v)
      },
      expression: "form.depositPaid"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Ref",
      "placeholder": "Ref",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.depositRef),
      callback: function($$v) {
        _vm.$set(_vm.form, "depositRef", $$v)
      },
      expression: "form.depositRef"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.form.rightOfWay && _vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Right of Way")])])])]), _vm._v(" "), _c('el-row', {
    staticClass: "padded",
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Right of Way",
      "placeholder": "ROW Charges",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.rightOfWayCharges),
      callback: function($$v) {
        _vm.$set(_vm.form, "rightOfWayCharges", $$v)
      },
      expression: "form.rightOfWayCharges"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Exclusive Fee",
      "placeholder": "Exclusive Fee",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.exclusiveFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "exclusiveFee", $$v)
      },
      expression: "form.exclusiveFee"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.localNew) ? _c('el-collapse-item', {
    attrs: {
      "name": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Serivce")])]), _vm._v(" "), (_vm.form.startService) ? _c('span', [_vm._v(": from "), _c('b', [_vm._v(_vm._s(this.formatDate(_vm.form.startService)))]), (_vm.form.terminateService) ? _c('span', [_vm._v(" to "), _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(this.formatDate(_vm.form.terminateService)))])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-row', {
    staticClass: "padded",
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Serivce Start",
      "placeholder": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.startService),
      callback: function($$v) {
        _vm.$set(_vm.form, "startService", $$v)
      },
      expression: "form.startService"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Terminated",
      "placeholder": "Terminated",
      "disabled": !_vm.editMode && (this.form.status == 'Active')
    },
    model: {
      value: (_vm.form.terminateService),
      callback: function($$v) {
        _vm.$set(_vm.form, "terminateService", $$v)
      },
      expression: "form.terminateService"
    }
  })], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', [_c('b', [_vm._v("Sundry & Other Fees")])])])]), _vm._v(" "), _c('el-row', {
    staticClass: "padded",
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "md": 6
    }
  }, [_c('float-input', {
    attrs: {
      "label": "Recurring Fee",
      "placeholder": "Sundry Fees",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.recurringFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "recurringFee", $$v)
      },
      expression: "form.recurringFee"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "offset": 2
    }
  }, [_c('select-frequency', {
    attrs: {
      "label": "Frequency",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.frequency),
      callback: function($$v) {
        _vm.$set(_vm.form, "frequency", $$v)
      },
      expression: "form.frequency"
    }
  })], 1)], 1)], 2) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (this.form.others && this.form.others.length > 0) ? _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Other Customers")]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Provider")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Entrance Fee")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("ROW Fee")]), _vm._v(" "), _c('th', [_vm._v("Started")]), _vm._v(" "), _c('th', [_vm._v("Expiry")])])]), _vm._v(" "), _c('tfoot'), _vm._v(" "), _c('tbody', _vm._l((_vm.form.others), function(bh, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bh.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bh.organisation.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.form.providerShortName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(bh.entranceFee)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(bh.rowFee)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(bh.started)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatFriendlyDate(bh.expiry)))])])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.updated_at) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.form.updated_at)))]), _vm._v(" (" + _vm._s(_vm.formatDateTime(_vm.form.updated_at)) + ")"), (_vm.form.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.form.updated_by))]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-782cc5e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backhaul/BackhaulProvider.vue
// module id = 1648
// module chunks = 0